export default [
  {
    path: '/configuracaoConta', //PRECISA USAR ESSE DATA.ID
    name: 'ConfiguracoesPerfil',
    component: () => import('@/views/pages/conta-config/configuracaoConta.vue'),
    meta: {
      pageTitle: 'Alterar dados do perfil',
      requiresParametrizacao: true,
    },
  },
  {
    path: '/help/centralapoio', //PRECISA USAR ESSE DATA.ID
    name: 'centralapoio',
    component: () => import('@/views/pages/help/centralapoio.vue'),
    meta: {
      pageTitle: 'Central de apoio',
      requiresParametrizacao: true,
    },
  },
  {
    path: '/cadastro/modaltomador',
    name: 'modalCadastroTomador',
    component: () => import('@/views/components/Tomador/modalCadastroTomador.vue'),
    meta: {
      pageTitle: 'Tomador',
    },
  },
  {
    path: '/cadastro/grupoFolha',
    name: 'CadastroGrupoFolha',
    component: () => import('@/views/pages/cadastro/grupoFolha.vue'),
    meta: {
      pageTitle: 'Grupo Folha',
      requiresParametrizacao: true,
    },
  },
  {
    path: '/cadastro/tomador',
    name: 'CadastroTomador',
    component: () => import('@/views/pages/cadastro/tomador.vue'),
    meta: {
      pageTitle: 'Tomador',
      requiresParametrizacao: true,
    },
  },
  {
    path: '/cadastro/orgao',
    name: 'CadastroOrgao',
    component: () => import('@/views/pages/cadastro/orgao.vue'),
    meta: {
      pageTitle: 'Órgão',
      requiresParametrizacao: true,
    },
  },
  {
    path: '/UnidadeGestora',
    name: 'CadastroUnidadeGestora',
    component: () => import('@/views/pages/Configuracoes/Cliente/UnidadeGestora.vue'),
    meta: {
      pageTitle: 'Unidade Gestora',
      meta: { requiresAuth: true },
      requiresParametrizacao: true,
    },
  },
  {
    path: '/cessionaria',
    name: 'ConfiguracoesSistemaCessionariaAcessar',
    component: () => import('@/views/pages/Configuracoes/Cessionaria/Cessionaria.vue'),
    meta: {
      pageTitle: 'Cessionária',
      meta: { requiresAuth: true },
      requiresParametrizacao: true,
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/error/nao-autorizado.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/too-large',
    name: 'too-large',
    component: () => import('@/views/error/muito-grande.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/semCRP',
    name: 'semCRP',
    component: () => import('@/views/error/semCRP.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
]
